'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconRoadSignBanned = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M20.96 19.547a.253.253 0 0 0 .19.073.25.25 0 0 0 .181-.093A11.987 11.987 0 0 0 4.473 2.668a.251.251 0 0 0-.019.372zM3.04 4.454a.249.249 0 0 0-.19-.073.253.253 0 0 0-.182.092 11.987 11.987 0 0 0 16.858 16.859.247.247 0 0 0 .093-.181.249.249 0 0 0-.073-.19z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12c0-3.178 1.234-6.173 3.476-8.437a.238.238 0 0 1 .039-.048.335.335 0 0 1 .047-.037A11.918 11.918 0 0 1 12 0c6.617 0 12 5.383 12 12 0 3.177-1.234 6.172-3.474 8.436a.282.282 0 0 1-.088.088A11.92 11.92 0 0 1 12 24zM3.882 4.589A10.938 10.938 0 0 0 1 12c0 6.065 4.935 11 11 11 2.755 0 5.376-1.021 7.411-2.882L3.882 4.589zm16.236 14.822A10.936 10.936 0 0 0 23 12c0-6.065-4.935-11-11-11a10.938 10.938 0 0 0-7.411 2.882l15.529 15.529z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12a11.92 11.92 0 0 1 3.469-8.43.418.418 0 0 1 .098-.098A11.916 11.916 0 0 1 12 0c6.617 0 12 5.383 12 12a11.92 11.92 0 0 1-3.468 8.43.364.364 0 0 1-.099.098A11.916 11.916 0 0 1 12 24zM4.069 5.13A10.453 10.453 0 0 0 1.5 12c0 5.79 4.71 10.5 10.5 10.5 2.534 0 4.958-.909 6.87-2.569L4.069 5.13zm15.862 13.74A10.448 10.448 0 0 0 22.5 12c0-5.79-4.71-10.5-10.5-10.5-2.534 0-4.958.91-6.87 2.569L19.931 18.87z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconRoadSignBanned.displayName = 'IconRoadSignBanned';
exports.default = IconRoadSignBanned;